// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.methanol_suggestion_response_enum */
var MethanolSuggestionResponseEnum;
(function (MethanolSuggestionResponseEnum) {
    MethanolSuggestionResponseEnum["TAKING_SAMPLE"] = "TAKING_SAMPLE";
    MethanolSuggestionResponseEnum["ACTING"] = "ACTING";
    MethanolSuggestionResponseEnum["DISMISSED_EXPLAINED"] = "DISMISSED_EXPLAINED";
    MethanolSuggestionResponseEnum["DISMISSED_UNLIKELY"] = "DISMISSED_UNLIKELY";
    MethanolSuggestionResponseEnum["DISMISSED_HANDLING"] = "DISMISSED_HANDLING";
})(MethanolSuggestionResponseEnum || (MethanolSuggestionResponseEnum = {}));
;
export default MethanolSuggestionResponseEnum;
/** Zod schema for methanol_suggestion_response_enum */
export const methanolSuggestionResponseEnum = z.nativeEnum(MethanolSuggestionResponseEnum);
//# sourceMappingURL=MethanolSuggestionResponseEnum.js.map